module.exports = __webpack_public_path__ + "img/cc02c7e6f708d507461f03db72821a66.png";